import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import {FlujoVentaPasoAdjunto} from '../_models/flujo-venta-paso-adjunto';

@Injectable({
  providedIn: 'root'
})
export class FlujoVentaPasoAdjuntoService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/flujoVentaPasosAdjuntos';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as FlujoVentaPasoAdjunto[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as FlujoVentaPasoAdjunto[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as FlujoVentaPasoAdjunto ) );
  }

  obtenerPorIdFlujoVentaPaso( idFlujoVentaPaso: string ) {
    return this.httClient.get( this.rutServicio + '/flujoVenta/' + idFlujoVentaPaso ).pipe( map( res => res as FlujoVentaPasoAdjunto ) );
  }

  crear( regCrear: FlujoVentaPasoAdjunto ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as FlujoVentaPasoAdjunto ) );
  }

  actualizar( regActualizar: FlujoVentaPasoAdjunto ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as FlujoVentaPasoAdjunto ) );
  }
}
